module.exports = __webpack_public_path__ + "static/halfSectionWithPattern-981d29fc8dd17bd8c3aef848c63221f3.png";